export const iconFontAwesomeTransportationJetFighterUp = (
	<i className="fa-solid fa-jet-fighter-up"></i>
);
